/**
 * Global Service & Event Constants
 * Aligned with the unified architecture.
 */
export const SERVICE_NAMES = {
  USERS: 'user-service',
  INGESTION: 'ingestion-service',
  AI_ENGINE: 'ai-predictive-engine',
  REALTIME: 'realtime-gateway',
  ADMIN: 'admin-service'
};

export const EVENTS = {
  VITALS_RECEIVED: 'vitals_update',
  ANALYSIS_COMPLETED: 'analysis_complete',
  ALERT_TRIGGERED: 'alert',
  EMERGENCY_DISPATCH: 'emergency_dispatch',
  FEATURE_ANNOUNCEMENT: 'feature_announcement'
};

export const CONDITIONS = {
  CARDIAC: 'cardiac',
  NEURO: 'neuro',
  DIABETIC: 'diabetic',
  GENERAL: 'general'
};